// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFilterValuesValuesFromJSON, DatapointFilterValuesValuesToJSON, } from './';
export function DatapointFilterValuesFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'values': !exists(json, 'values') ? undefined : json['values'].map(DatapointFilterValuesValuesFromJSON),
        'minNumberValue': !exists(json, 'minNumberValue') ? undefined : json['minNumberValue'],
        'maxNumberValue': !exists(json, 'maxNumberValue') ? undefined : json['maxNumberValue'],
    };
}
export function DatapointFilterValuesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'values': value.values === undefined ? undefined : value.values.map(DatapointFilterValuesValuesToJSON),
        'minNumberValue': value.minNumberValue,
        'maxNumberValue': value.maxNumberValue,
    };
}
